import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
    selector: 'bw-tracker-legacy',
    templateUrl: './tracker.component.html',
    styleUrls: ['./tracker.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TrackerComponentLegacy implements OnInit {

  @Input() trackerSteps: any[];

  constructor() { }

  ngOnInit(): void {
  }

}
